module.exports = __webpack_public_path__ + "img/rugs-and-runners.7947ecc.jpg";